import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import initSentry from './sentry.ts'
import { AuthProvider } from './contexts/AuthContext.tsx'
import { ApolloProvider } from '@apollo/client'
import apolloClient from './lib/apollo.ts'
import { DashboardProvider } from './contexts/DashboardProvider.tsx'
import { LicenseInfo } from '@mui/x-license';
import { VITE_MUI_PRO_KEY } from './utils/env.ts'
import { insightsTheme } from './utils/theme.ts'
import { ThemeProvider } from '@mui/material/styles'
import { IntercomManager } from './lib/Intercom.tsx'

LicenseInfo.setLicenseKey(VITE_MUI_PRO_KEY);


initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
        <ThemeProvider theme={insightsTheme}>
          <DashboardProvider>
            <IntercomManager />
            <div className="min-h-screen bg-gray-100 text-gray-900">
              <App />
            </div>
          </DashboardProvider>
        </ThemeProvider>
      </AuthProvider>
    </ApolloProvider>
  </StrictMode>,
)
